(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waifu-etsy-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('waifu-reviews')) {
    customElements.define('waifu-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.ws-rv-track');
        if (!this.track) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = Array.from(this.querySelectorAll('.ws-rv-card'));
        this.prev = this.querySelector('[data-rv-prev]');
        this.next = this.querySelector('[data-rv-next]');
        this.range = this.querySelector('[data-rv-range]');
        this.filters = Array.from(this.querySelectorAll('[data-rv-filter]'));
        this.classList.add('is-enhanced');
        this.querySelector('.ws-rv-navigation').hidden = false;
        this.querySelector('.ws-rv-filters').hidden = this.filters.length < 3;
        this.prev.addEventListener('click', () => this.step(-1), options);
        this.next.addEventListener('click', () => this.step(1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(event.key === 'ArrowLeft' ? -1 : 1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.motion() });
          }
        }, options);
        this.filters.forEach(button => button.addEventListener('click', () => {
          this.filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.cards.forEach(card => { card.hidden = button.dataset.rvFilter !== 'all' && card.dataset.rvStyle !== button.dataset.rvFilter; });
          this.track.scrollTo({ left: 0, behavior: 'instant' });
          this.measure();
          this.querySelector('[data-rv-status]').textContent = this.dataset.filtered.replace('[count]', this.visibleCards().length).replace('[style]', button.dataset.rvStyle);
        }, options));
        this.cards.forEach(card => {
          const button = card.querySelector('.ws-rv-readmore');
          button.addEventListener('click', () => {
            const open = card.classList.toggle('is-open');
            button.textContent = open ? this.dataset.less : this.dataset.more;
            button.setAttribute('aria-expanded', String(open));
          }, options);
        });
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
        this.measure();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      visibleCards() { return this.cards.filter(card => !card.hidden); }
      motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'; }
      measure() {
        this.visibleCards().forEach(card => {
          const text = card.querySelector('.ws-rv-text');
          const button = card.querySelector('.ws-rv-readmore');
          const open = card.classList.contains('is-open');
          if (open) card.classList.remove('is-open');
          const truncated = text.scrollHeight > text.clientHeight + 2;
          if (open) card.classList.add('is-open');
          button.hidden = !truncated && !open;
        });
        this.update();
      }
      update() {
        const cards = this.visibleCards();
        const box = this.track.getBoundingClientRect();
        const shown = cards.map((card, index) => ({ index, box: card.getBoundingClientRect() }))
          .filter(item => item.box.left < box.right - 8 && item.box.right > box.left + 8);
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
        this.range.textContent = this.dataset.range.replace('[first]', shown.length ? shown[0].index + 1 : 0)
          .replace('[last]', shown.length ? shown[shown.length - 1].index + 1 : 0).replace('[total]', cards.length);
      }
      step(direction) {
        const cards = this.visibleCards();
        const stride = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : this.track.clientWidth;
        const count = Math.max(1, Math.floor((this.track.clientWidth + 2) / stride));
        this.track.scrollBy({ left: direction * stride * count, behavior: this.motion() });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
